import { IIntegrationList, ISettings } from '../interfaces/ISettings';

// Settings Mapper for handling settings data transformations
export class SettingsMapper {
  /**
   * Transform API response to ISettings interface
   */
  static afterLoadRequest(settings: ISettings): ISettings {
    if (!settings) return null;

    return settings;
  }

  static toCompanyIntegration(integration: any[]): IIntegrationList[] {
    const integrationType = {
      '1': 'settings.integration-mantis',
    };

    return (integration || []).map((item) => ({
      id: item?.id ?? 0,
      name: item?.name ?? '',
      description: item?.description ?? '',
      isActive: item?.isActive ?? true,
      title: integrationType[item?.integration] || '',
    }));
  }
}
